import { faFlaskVial } from '@fortawesome/pro-light-svg-icons';

import { MostSearchedResultType, SearchType } from '@/types/most-search-type';

export const mostSearchesVaccines: MostSearchedResultType = {
  title: 'Vacinas',
  type: SearchType.VACCINE,
  iconName: faFlaskVial,
  procedures: [
    {
      id: 'f9babf5e-e02d-4451-8682-ea4699d66e78',
      type: SearchType.VACCINE,
      name: 'Vacina HPV Quadrivalente',
      displayName: 'Vacina HPV Quadrivalente',
      code: '10001124',
      slug: 'vacina-de-hpv-quadrivalente',
      alias: 'Vacina HPV Quadrivalente',
    },
    {
      id: '633d4c91-d740-441f-b5f9-aca140f93102',
      type: SearchType.VACCINE,
      name: 'Vacina Contra Gripe Influenza',
      displayName: 'Vacina Contra Gripe Influenza',
      code: '10001100',
      slug: 'vacina-contra-gripe-influenza',
      alias: 'Vacina Contra Gripe Influenza',
    },
    {
      id: 'ec236243-eb96-4bf6-a58c-2521cb8d6c02',
      type: SearchType.VACCINE,
      name: 'Vacina de Pneumo Conjugada 13 Valente',
      displayName: 'Vacina de Pneumo Conjugada 13 Valente',
      code: '10001116',
      slug: 'vacina-de-pneumo-conj-13-val',
      alias: 'Vacina de Pneumo Conjugada 13 Valente',
    },
    {
      id: 'fca3a5ee-e898-4faf-acfa-4a4565ba45c7',
      type: SearchType.VACCINE,
      name: 'Vacina Contra o Herpes Zoster',
      displayName: 'Vacina Contra o Herpes Zoster',
      code: '10001125',
      slug: 'vacina-contra-o-herpes-zoster',
      alias: 'Vacina Contra o Herpes Zoster',
    },
    {
      id: 'cfd38447-3c97-40f9-9eaf-219e0e1b630e',
      type: SearchType.VACCINE,
      name: 'Vacina Tríplice Viral (Sarampo-Caxumba-Rubéola) SCR',
      displayName: 'Vacina Tríplice Viral (Sarampo-Caxumba-Rubéola) SCR',
      code: '10001119',
      slug: 'vacina-de-sarampo-caxumba-rubeola-scr',
      alias: 'Vacina Tríplice Viral (Sarampo-Caxumba-Rubéola) SCR',
    },
  ],
};
